import { useRef, useEffect, useCallback } from 'react';

/**
 * Calls clearTimeout if the component unmounts.
 */
export function useTimeout() {
  const timerIds = useRef<number[]>([]);

  useEffect(() => {
    return function onUnmount() {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      timerIds.current.forEach((id) => clearTimeout(id));
    };
  }, []);

  const setTimeoutSafe = useCallback((callback: () => void, ms: number) => {
    const timerId = window.setTimeout(callback, ms);
    timerIds.current.push(timerId);
    return timerId;
  }, []);

  return { setTimeoutSafe };
}
